module.exports = __webpack_public_path__ + "media/loudspeaker_selfservice.b1f4cc82.webm";